export const CLEAR_ALL_DEDUCTIONS = 'CLEAR_ALL_DEDUCTIONS'
export const CLEAR_ALL_DEDUCTIONS_PENDING = 'CLEAR_ALL_DEDUCTIONS_PENDING'
export const CLEAR_ALL_DEDUCTIONS_FULFILLED = 'CLEAR_ALL_DEDUCTIONS_FULFILLED'
export const CLEAR_ALL_DEDUCTIONS_REJECTED = 'CLEAR_ALL_DEDUCTIONS_REJECTED'

export const ATTENDANCE_UPDATE_DEDUCTIONS = 'ATTENDANCE_UPDATE_DEDUCTIONS'
export const ATTENDANCE_UPDATE_DEDUCTIONS_PENDING = 'ATTENDANCE_UPDATE_DEDUCTIONS_PENDING'
export const ATTENDANCE_UPDATE_DEDUCTIONS_FULFILLED = 'ATTENDANCE_UPDATE_DEDUCTIONS_FULFILLED'
export const ATTENDANCE_UPDATE_DEDUCTIONS_REJECTED = 'ATTENDANCE_UPDATE_DEDUCTIONS_REJECTED'
